import { createTheme  } from '@material-ui/core';

const theme = createTheme ({
  palette: {
    primaryGreen:  "#a9d92c"
  }
});

export default theme;
